import { sanitizeFilename } from './dom'

function normalizeCoverUrl (url: string): string {
  // Some CDNs insert sizing directives like `._SY425_` or `._SX342_SY445_`
  // right before the file extension.
  return url.replace(/\._[A-Z0-9,]+_\.(jpg|jpeg|png|webp)$/i, '.$1')
}

export function maybeDownloadCover (title: string, coverUrl?: string): void {
  if (!coverUrl) return

  const normalizedCoverUrl = normalizeCoverUrl(coverUrl)

  GM_download({
    url: normalizedCoverUrl,
    name: `${sanitizeFilename(title)}_Cover.jpg`,
    headers: { Referer: window.location.href }
  })
}
